import { useEffect, useState } from 'react';
import { MyFooter } from '../landingpage/MyFooter';
import { MyHeader } from '../header/MyHeader';
import MenuComponent from '../component/MenueComponent';

type IErgebnisse = {
  position: number,
  name: string,
  verein: string,
  startnummer: string,
  time: string,
  sekunden: number,
  formatiert: string,
}

type IKategorien = {
  name: string,
  text: string,
  start: string,
  Ergebnisse: IErgebnisse[]
}

type ISatz = {
  ereignisname: string,
  Kategorien: IKategorien[],
}

export function Rangliste() {

  const [data, setData] = useState<ISatz[]>([]);

  const getData = () => {
    fetch('https://volkslauf-neermoor.de/rest/restGetRangliste.rest', {
      method: 'get',
    })
      .then(resp => resp.json())
      .then(setData)
      .catch((e) => console.log(e));
  }

  const getDifferenz = (date1: string, date2: string) => {

    const start = new Date(date1);
    const end = new Date(date2);

    const diffMs = end.getTime() - start.getTime(); // Millisekunden
    const totalSeconds = Math.floor(diffMs / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // Hilfsfunktion zum Formatieren mit führenden Nullen
    const pad = (n: number) => String(n).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {/*<MyHeader />*/}

      <div className='container'>

        <div className='content row'>

          <MenuComponent aktuelleseite="rangliste" />

          <h2 style={{ textAlign: "center", width: "100%" }}>Rangliste</h2>

          {data.map((e) => <>
            <h3 style={{ textAlign: "center", width: "100%" }}>{e.ereignisname}</h3>

            {e.Kategorien.map((k) => <>
              <legend>{k.text}</legend>

              <table className="table">

                <tr>
                  <th>Position</th>
                  <th>Startnummer</th>
                  <th>Name</th>
                  <th>Team</th>
                  <th>Laufzeit</th>
                </tr>

                {k.Ergebnisse.map((t) => <>
                  <tr>
                    <td>{t.position}</td>
                    <td>{t.startnummer}</td>
                    <td>{t.name}</td>
                    <td>{t.verein}</td>
                    <td>{getDifferenz(k.start, t.time)}</td>
                  </tr>
                </>)}

              </table >
            </>)}
          </>)}
        </div >
      </div>

      <MyFooter />
    </>
  );
}

function axios(arg0: string, arg1: { method: string; }) {
  throw new Error('Function not implemented.');
}

export default Rangliste;